"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This can be used to help TypeScript understand when we've exhaustively matched against a
// all possible variants of a type. By setting type of `value` to `never` we effectively trick
// TypeScript into statically checking for exhaustiveness. Particualarly useful when using
// /matching against all options in string literal types.
class UnsupportedValueError extends Error {
    constructor(value) {
        super('Unsupported value: ' + value);
    }
}
exports.default = UnsupportedValueError;
//# sourceMappingURL=UnsupportedValueError.js.map